import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import BottomNav from './BottomNav';
import './Auth.css';

const defaultWorker = {
  name: 'Barnav Basu',
  location: 'Varikoli',
  price: 700,
  rating: 4.5,
  works: 127,
  months: 5,
  skills: ['welding', 'cutting', 'roofing'],
  reviews: [
    { name: 'Surendran', date: '10/09/2024', text: 'Barnav Basu exceeded my expectations. His roofing works are beyond spectacular.' },
    { name: 'Satheeshan', date: '02/09/2024', text: 'Barnav Basu worked pretty well. He is dedicated in his work. The welding and cutting of my new gate was almost perfect.' }
  ],
};

const ProfileWorker = () => {
  const { state } = useLocation();
  const worker = state || defaultWorker;
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    date: '',
    time: '',
    phone: '',
    landmark: '',
    payment: 'cash',
  });
  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = e => {
    e.preventDefault();
    alert('Booking submitted!');
    setShowModal(false);
  };
  return (
    <div className="auth-container" style={{paddingBottom: 80}}>
      <div style={{background: '#0090d0', borderRadius: '0 0 40px 40px', padding: '32px 0 24px 0', margin: '-32px -24px 24px -24px', position: 'relative'}}>
        <div style={{position: 'absolute', left: 18, top: 8, color: '#fff', fontSize: 14}}>16:00</div>
        <div style={{position: 'absolute', right: 18, top: 8, color: '#fff', fontSize: 14}}>📶 🔋</div>
        <div style={{width: 90, height: 90, borderRadius: '50%', background: '#222', margin: '0 auto', marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <span style={{fontSize: 48, color: '#fff'}}>👤</span>
        </div>
        <div style={{color: '#fff', fontWeight: 'bold', fontSize: 22, marginBottom: 2}}>{worker.name}</div>
        <div style={{color: '#fff', fontSize: 16}}>{worker.location} &nbsp; ₹{worker.price}</div>
      </div>
      <div style={{margin: '0 0 16px 0', borderBottom: '1px solid #eee', borderTop: '1px solid #eee', padding: '12px 0', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 32}}>
        <div style={{textAlign: 'center'}}>
          <div style={{fontWeight: 700, fontSize: 18}}>{worker.works}</div>
          <div style={{fontSize: 13, color: '#888'}}>Works</div>
        </div>
        <div style={{textAlign: 'center'}}>
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 18}}>{worker.rating} <span style={{color: '#f7b500', marginLeft: 4}}>★</span></div>
        </div>
        <div style={{textAlign: 'center'}}>
          <div style={{fontWeight: 700, fontSize: 18}}>{worker.months}</div>
          <div style={{fontSize: 13, color: '#888'}}>Months</div>
        </div>
      </div>
      <div style={{textAlign: 'left', marginBottom: 16}}>
        <div style={{fontWeight: 'bold', marginBottom: 6}}>Skills</div>
        <div style={{marginBottom: 12}}>
          {worker.skills.map(skill => (
            <span className="search-chip" key={skill}>{skill}</span>
          ))}
        </div>
        <div style={{fontWeight: 'bold', marginBottom: 6}}>Reviews</div>
        {worker.reviews.map((review, idx) => (
          <div className="review-card" key={idx} style={{marginBottom: 10}}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
              <b>🧑 {review.name}</b>
              <span style={{fontSize: 12, color: '#888'}}>{review.date}</span>
            </div>
            <div style={{margin: '4px 0'}}>
              <span style={{color: '#f7b500'}}>★★★★★</span>
            </div>
            <div>{review.text}</div>
          </div>
        ))}
      </div>
      <button className="auth-btn" onClick={() => setShowModal(true)}>Book</button>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Book Worker</h3>
            <form className="auth-form" onSubmit={handleSubmit}>
              <label>Date
                <input type="date" name="date" value={form.date} onChange={handleChange} required />
              </label>
              <label>Time of Arrival
                <input type="time" name="time" value={form.time} onChange={handleChange} required />
              </label>
              <label>Phone Number
                <input type="tel" name="phone" value={form.phone} onChange={handleChange} required pattern="[0-9]{10}" maxLength={10} />
              </label>
              <label>Landmark
                <input type="text" name="landmark" value={form.landmark} onChange={handleChange} required />
              </label>
              <div style={{marginBottom: 10}}>
                <span>Payment Method: </span>
                <label style={{marginRight: 10}}>
                  <input type="radio" name="payment" value="cash" checked={form.payment==='cash'} onChange={handleChange} /> Cash
                </label>
                <label>
                  <input type="radio" name="payment" value="online" checked={form.payment==='online'} onChange={handleChange} /> Online
                </label>
              </div>
              <div style={{display:'flex', gap:8}}>
                <button type="submit" className="auth-btn" style={{flex:1}}>Submit</button>
                <button type="button" className="auth-btn" style={{background:'#eee',color:'#0074a6',flex:1}} onClick={()=>setShowModal(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
      <BottomNav />
    </div>
  );
};

export default ProfileWorker; 